import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/$dashboardId/documentos-digitais/modelos',
      params: { dashboardId: params.dashboardId },
    })
  },
})
